import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { ApiReadiness } from '../lib/readiness';
import { ReadinessLadder } from './ReadinessLadder';

// The repo scope of the readiness ladder — chrome only.
//
// The rendering moved to `<ReadinessLadder/>` when the ACCOUNT scope arrived
// (the onboarding terminal card and Home). What differs between the two scopes
// is three sentences; what does not differ is the rung names, the three status
// labels, the seven `cleared_by` sentences and the whole list body. Those are
// one implementation and one `readiness.*` catalog namespace, so a rung added
// to the route gets its label in one place and both surfaces render it.
//
// This wrapper stays rather than folding its three `t()` calls into RepoDetail:
// the route names the SCOPE it is asking about, and keeping that here means the
// call site cannot accidentally pass the account's wording to the repo ladder.
export function RepoReadiness(props: { readonly ladder: ApiReadiness }): JSX.Element {
  return (
    <ReadinessLadder
      ladder={props.ladder}
      title={t('readiness.repo_title')}
      desc={t('readiness.repo_desc')}
      source={t('readiness.repo_source')}
    />
  );
}
